"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchDeliveryOptions = void 0;
const module_cart_b2ag_interfaces_1 = require("@invivodf/module-cart-b2ag-interfaces");
const searchDeliveryOptions = (searchHomeDeliveryOptions, searchPickupPointDeliveryOptions) => async ({ checkoutId, consignmentId, addressId, logisticRoute, logisticOfferId }) => {
    switch (logisticRoute) {
        case module_cart_b2ag_interfaces_1.LogisticRoute.HomeDelivery:
            return searchHomeDeliveryOptions({
                addressId,
                checkoutId,
                consignmentId,
                logisticOfferId
            });
        case module_cart_b2ag_interfaces_1.LogisticRoute.PickupPoint:
            return searchPickupPointDeliveryOptions({
                addressId,
                checkoutId,
                consignmentId,
                logisticOfferId
            });
        default:
            throw new Error(`Unsupported logistic route: ${logisticRoute}`);
    }
};
exports.searchDeliveryOptions = searchDeliveryOptions;
